export default __webpack_public_path__ + "static/Bild Seite 3 - Verkäuferin-8396b74feedc0b784e265bbfeafdfc44.jpg";